import { MenuItem } from "./MenuItem";
import { useAuth } from "../../../../app/modules/auth/hooks/UseAuth";
import { appPages } from "../../../../app/routing/appPages";

export function MenuInner() {
  const { roleList } = useAuth()

  const visibleMenuItems = appPages.filter(
    page => page.menuTitle && page.canAccess(roleList)
  );

  if (visibleMenuItems.length <= 1) {
    return null;
  }
  return (
    <>
      {visibleMenuItems.map(page => (
        <MenuItem key={page.path} title={page.menuTitle as string} to={page.path} />
      ))}
    </>
  );
}
